import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_CHANNEL = "GET_LIST_CHANNEL";
export const GET_LIST_CHANNEL_ERROR = "GET_LIST_CHANNEL_ERROR";
export const GET_LIST_CHANNEL_SUCCESS = "GET_LIST_CHANNEL_SUCCESS";

export const COUNT_NUMBER_CHANNEL = "COUNT_NUMBER_CHANNEL";
export const COUNT_NUMBER_CHANNEL_ERROR = "COUNT_NUMBER_CHANNEL_ERROR";
export const COUNT_NUMBER_CHANNEL_SUCCESS = "COUNT_NUMBER_CHANNEL_SUCCESS";

export const GET_LIST_ACTIVE_CALL = "GET_LIST_ACTIVE_CALL";
export const GET_LIST_ACTIVE_CALL_SUCCESS = "GET_LIST_ACTIVE_CALL_SUCCESS";
export const GET_LIST_ACTIVE_CALL_ERROR = "GET_LIST_ACTIVE_CALL_ERROR";

/**
 * Reducer
 */

const initialState = {
  channel: [],
  error: false,
  count: 0,
  loading: false,
  activeCall: [],
};

export const channelReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_CHANNEL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_CHANNEL_SUCCESS:
      return {
        ...state,
        loading: false,
        channel: action.payload,
      };
    case GET_LIST_CHANNEL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_NUMBER_CHANNEL:
      return {
        ...state,
      };
    case COUNT_NUMBER_CHANNEL_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_NUMBER_CHANNEL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //
    case GET_LIST_ACTIVE_CALL:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_ACTIVE_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        activeCall: action.payload,
      };
    case GET_LIST_ACTIVE_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListChannel = (order, limit, skip, where) => ({
  type: GET_LIST_CHANNEL,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countChannel = (where) => ({
  type: COUNT_NUMBER_CHANNEL,
  data: {
    where,
  },
});

export const getActiveCall = (extensionId) => ({
  type: GET_LIST_ACTIVE_CALL,
  data: {
    extensionId,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListChannel,
      countChannel,
      getActiveCall,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListChannelApi = (order, limit, skip, where) => {
  return apiCaller.get("/cloud-pbx/channel", { order, limit, skip, ...where });
};

const countChannelApi = (where) => {
  return apiCaller.getData("/cloud-pbx/channel/count", { ...where });
};

const getActiveCallApi = (extensionId) => {
  return apiCaller.getLogs("/cloud-pbx/active-call", { ...extensionId });
};
/**
 * sagas
 */

export const getListChannelFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CHANNEL);
    try {
      const res = yield call(
        getListChannelApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_CHANNEL_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_CHANNEL_ERROR, error });
    }
  }
};

export const countChannelFlow = function* () {
  while (true) {
    const action = yield take(COUNT_NUMBER_CHANNEL);
    try {
      const res = yield call(countChannelApi, action.data.where);
      yield put({
        type: COUNT_NUMBER_CHANNEL_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_NUMBER_CHANNEL_ERROR, error });
    }
  }
};

export const getActiveCallFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_ACTIVE_CALL);
    try {
      const res = yield call(getActiveCallApi, action.data.extensionId);
      res.data.sort(function (a, b) {
        return (
          new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime()
        );
      });
      yield put({ type: GET_LIST_ACTIVE_CALL_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_ACTIVE_CALL_ERROR, error });
    }
  }
};
